<script>
import { mapGetters } from 'vuex';
import EventSelectionModalLongForm from './EventSelectionModalLongForm.vue';
import HarnessSelectionStats from '../../FormGuideSelectionStats/HarnessSelectionStats.vue';

export default {
  name: 'EventSelectionModalForm',
  components: {
    EventSelectionModalLongForm,
    HarnessSelectionStats,
  },
  props: {
    selectionData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isDetailsActive: false,
      addedGearChanges: '',
      removedGearChanges: '',
    };
  },

  computed: {
    ...mapGetters({
      raceType: 'FormGuideEventCard/getRaceType',
    }),
    selectionStats() {
      return this.selectionData ? this.selectionData.stats : [];
    },
    isHarness() {
      return this.raceType == 'harness';
    },
    gearChanges() {
      return this.selectionData.gear_changes || [];
    },
    hasGearChanges() {
      return this.selectionData.gear_changes ? this.selectionData.gear_changes.length > 0 : false;
    },
    // only return records with results
    // added extra check to make sure competitor is not scratched
    // add another check to hide abandoned events
    formRecords() {
      const { records } = this.selectionData;
      const { isCompetitorScratched, isEventAbandoned } = this;
      return records
        ? records.filter(item => !isEventAbandoned(item) && item.results.length > 0 && !isCompetitorScratched(item))
        : [];
    },
  },
  mounted() {
    this.setGearChanges();
  },
  methods: {
    toggleBlackbookModal() {
      this.$store.dispatch('FormGuideEventCard/toggleBlackbookModal');
    },
    setGearChanges() {
      // filter tips and add to added/removed gear changes strings
      if (this.gearChanges.length > 0) {
        const addedFiltered = this.selectionData.gear_changes.filter(item => {
          if (item.status === 1) {
            return item.gear_name;
          }
        });

        const addedArray = addedFiltered.map(e => {
          return e.gear_name;
        });

        const removedFiltered = this.selectionData.gear_changes.filter(item => {
          if (item.status === 0) {
            return item.gear_name;
          }
        });

        const removedArray = removedFiltered.map(e => {
          return e.gear_name;
        });

        this.addedGearChanges = addedArray.length > 0 ? ` ${addedArray.join(', ')}` : '';
        this.removedGearChanges = removedArray.length > 0 ? `${removedArray.join(', ')}` : '';
      }
    },
    isCompetitorScratched(record) {
      const { selectionData } = this;
      const { selections } = record;
      const scratchedArray = selections
        ? selections.filter(item => item.competitor_id === selectionData.competitor_id && item.status === 'scratched')
        : [];
      return scratchedArray.length > 0;
    },
    isEventAbandoned(event) {
      return event.status === 'Abandoned';
    },
  },
};
</script>

<template>
  <div class="event-select-modal-form">
    <!-- form header -->
    <div class="event-select-modal-form__header">
      <div class="event-select-modal-form__row">
        <div class="event-selection-modal-form__column">
          <div class="event-selection-modal-column__header">COLOUR</div>
          <div class="event-selection-modal-column__details">{{ selectionData.competitor.colour }}</div>
        </div>
        <div class="event-selection-modal-form__column">
          <div class="event-selection-modal-column__header">AGE/SEX</div>
          <div
            class="event-selection-modal-column__details"
          >{{ selectionData.competitor.age }}yo {{ selectionData.competitor.sex }}</div>
        </div>
      </div>
      <div class="event-select-modal-form__row">
        <div class="event-selection-modal-form__column-full">
          <div class="event-selection-modal-column__header">OWNERS</div>
          <div class="event-selection-modal-column__details">{{ selectionData.competitor.owner }}</div>
        </div>
      </div>
    </div>

    <!-- form details grid 4x4 -->
    <div class="event-select-modal-form__details">
      <div class="event-select-modal-form-details__middle">
        <!-- stats grid section -->
        <template v-if="isHarness">
          <HarnessSelectionStats :is-mobile="true" :selection-stats="selectionStats" />
        </template>
        <!-- form details bottom -->
        <div v-if="hasGearChanges" class="event-select-modal-form-details__bottom">
          <div class="event-selection-modal-column__header">GEAR CHANGES</div>
          <div class="event-selection-modal-column__details">
            <div class="event-selection-row-column__details">
              <div class="gear-changes-row">
                <span v-if="addedGearChanges">
                  <b>Added:</b>
                  {{ addedGearChanges }}
                </span>
                <span v-if="removedGearChanges">
                  <b>Removed:</b>
                  {{ removedGearChanges }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- blackbook button -->
    <div v-if="!isHarness" class="event-select-modal-form-details__btns">
      <a
        href="#"
        class="event-select-modal-form-details__bb-btn"
        @click.prevent="toggleBlackbookModal"
      >
        <p>View Blackbook Comments</p>
        <span class="bb-btn-message-count">
          <p>0</p>
        </span>
      </a>
    </div>
    <!-- Selections long form -->
    <template v-if="formRecords.length > 0">
      <EventSelectionModalLongForm
        :competitor-id="selectionData.competitor_id"
        :records="formRecords"
      />
    </template>
  </div>
</template>
